import { Field, Form, Formik } from "formik";
import * as Yup from "yup";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import TextField from "@mui/material/TextField";

interface IFlagDataModalTypedProperties {
  flagCompanyIssue: (feedback: string, issue: string) => void;
  form: string;
}

interface IIssueOptions {
  label: string;
  value: string;
}

export default function FlagDataModalTyped({ flagCompanyIssue, form }: IFlagDataModalTypedProperties) {
  const validationSchema = Yup.object().shape({
    feedback: Yup.string(),
    issue: Yup.string().required("Issue type is required"),
  });

  let issueOptions: IIssueOptions[] = [];
  if (form === "company") {
    issueOptions = [
      { label: "Company is not active.", value: "not_active" },
      { label: "Company information is not correct.", value: "incorrect_company_info" },
      { label: "Company patents are incorrect.", value: "incorrect_patent_data" },
      { label: "This company is not relevant to my search.", value: "not_relevant" },
    ];
  } else if (form === "contact") {
    issueOptions = [
      { label: "Contact no longer works here.", value: "no_longer_employed" },
      { label: "Contact information is incorrect.", value: "incorrect_contact_info" },
    ];
  }

  return (
    <Box sx={{ p: 1, width: "40rem" }}>
      <Formik
        initialValues={{
          feedback: "",
          issue: "",
        }}
        onSubmit={async (values, { setSubmitting }) => {
          setSubmitting(true);
          flagCompanyIssue(values.feedback, values.issue);
          setSubmitting(false);
        }}
        validationSchema={validationSchema}
      >
        {({ dirty, errors, isSubmitting, isValid, touched }) => (
          <Form>
            <FormControl component="fieldset" fullWidth margin="none">
              <FormLabel component="legend" sx={{ fontWeight: "600", mb: 1 }}>
                What&apos;s the issue with this {form}? How can it be improved?
              </FormLabel>
              <Field
                as={TextField}
                fullWidth
                helperText={touched.feedback ? errors.feedback : ""}
                label="Add your feedback here..."
                margin="normal"
                multiline
                name="feedback"
                rows={3}
              />
            </FormControl>
            <Field as={RadioGroup} name="issue">
              {issueOptions.map((option) => (
                <FormControlLabel control={<Radio />} key={option.value} label={option.label} value={option.value} />
              ))}
            </Field>
            <Button
              color="primary"
              disabled={isSubmitting || !isValid || !dirty}
              fullWidth
              sx={{ mt: 3 }}
              type="submit"
              variant="contained"
            >
              {isSubmitting ? <CircularProgress size={20} /> : "Submit"}
            </Button>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
